/**
 * Constantes centralizadas para las claves de localStorage relacionadas con autenticación.
 * 
 * Estas constantes deben ser usadas en lugar de strings literales para evitar
 * inconsistencias y facilitar el mantenimiento.
 */
export const AUTH_TOKEN_KEY = 'g-auth-token';
export const LAST_CONNECTION_DATE_KEY = 'lastConectionDate';
export const REFRESH_TOKEN_KEY = 'g-refresh-token';
export const TOKEN_EXPIRES_AT_KEY = 'g-token-expires-at';
export const LAST_ACTIVITY_TIMESTAMP_KEY = 'g-last-activity-timestamp';
export const LAST_REFRESH_ATTEMPT_KEY = 'g-last-refresh-attempt';

export const REFRESH_COORDINATION_WINDOW_MS = 5000;
export const REFRESH_THRESHOLD_SECONDS = 5 * 60;
export const TOKEN_EXPIRATION_ALERT_SECONDS = 60;
export const INACTIVITY_ALERT_SECONDS = 10;
export const INACTIVITY_LOGOUT_SECONDS = 60;
export const CHECK_INTERVAL_MS = 10000;
export const CHECK_INTERVAL_BACKGROUND_MS = 30000;
export const ACTIVITY_THROTTLE_MS = 10000;
